import React, { useEffect, useState } from 'react'
import { EmptyItemModel, IItemModel } from './ItemsApp'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { Avatar, Skeleton } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import BasicDataViewer, { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import ItemTransactions from '../transactions/ItemTransactions'
import CurrentItemLocation from './CurrentItemLocation'
import IssuesList from '../issues/IssuesList'
import ItemQrCode from './ItemQrCode'
import UnauthorizedBlock from '../../components/UnauthorizedBlock'
import ItemInventory from './ItemInventory'
import StatusChip from '../../components/StatusChip'
import ContainerItems from './ContainerItems'
import ItemCategory from './ItemCategory'
import Thumbnail from '../../components/Thumbnail'
import SingleItemQuantity from './SingleItemQuantity'
import ItemAdditionalData from './ItemAdditionalData'
import AttachmentsField from '../../components/Fields/AttachmentsField'
import Attachments from '../../components/Attachments'

interface IProps {
    item: IItemModel,
    usePublicDetails?: boolean
}

export default function SingleItemContent(props: IProps) {

    const { usePublicDetails } = props
    
    const [item, setItem] = useState<IItemModel>(EmptyItemModel)
    const [basicDataViewerItems, setBasicDataViewerItems] = useState<Array<IBasicDataViewItem>>([])

    const loading: boolean = item.id ? false : true

    useEffect(() => {

        setBasicDataViewerItems([
            {
                type: "text",
                label: "Title",
                value: item.title
            },
            {
                type: "status",
                label: "Status",
                value: item.status,
                privateDetails: usePublicDetails
            },
            {
                type: "status",
                label: "Condition",
                value: item.condition,
                privateDetails: usePublicDetails
            },
            {
                type: "status",
                label: "Type",
                value: item.is_container ? "container" : "regular",
                privateDetails: usePublicDetails
            },
            // {
            //     type: "text",
            //     label: "Current Location",
            //     value: "",
            //     customContent: () => <CurrentItemLocation returnToOrigin={true} item={item} />,
            //     privateDetails: usePublicDetails
            // },
            {
                type: "text",
                label: "Category",
                value: item.category_title,
                privateDetails: usePublicDetails,
                customContent() {
                    return <ItemCategory item={item} />
                },
            },
            {
                type: "text",
                label: "Brand",
                value: item.brand_title,
                privateDetails: usePublicDetails
            },
            // {
            //     type: "text",
            //     label: "Description",
            //     value: item.description,
            //     displayLabelNextLine: false,
            //     privateDetails: usePublicDetails,
            // },
            // {
            //     type: "text",
            //     label: "Total Quantity",
            //     value: `${item.quantity}`,
            //     privateDetails: usePublicDetails
            // },
            // {
            //     type: "text",
            //     label: "Available Quantity",
            //     value: `${item.available_quantity}`,
            //     privateDetails: usePublicDetails
            // },
            // {
            //     type: "text",
            //     label: "Reserved Quantity",
            //     value: `${item.reserved}`,
            //     privateDetails: usePublicDetails
            // },
            // {
            //     type: "text",
            //     label: "Damaged Quantity",
            //     value: `${item.damaged}`,
            //     privateDetails: usePublicDetails
            // },
            // {
            //     type: "text",
            //     label: "Missing Quantity",
            //     value: `${item.missing}`,
            //     privateDetails: usePublicDetails
            // },
            {
                type: "text",
                label: "Serial Number",
                value: item.serial_number,
                privateDetails: usePublicDetails
            },
            {
                type: "text",
                label: "Model",
                value: item.item_model,
                privateDetails: usePublicDetails
            },
            {
                type: "text",
                label: "Unique ID",
                value: item.unique_id
            },
            // {
            //     type: "text",
            //     label: "Warehouse",
            //     value: item.warehouse_title
            // },
            // {
            //     type: "text",
            //     label: "Section",
            //     value: item.section_title
            // },
            {
                type: "text",
                label: "Weight",
                value: item.weight ? `${item.weight}kg` : "-",
                privateDetails: usePublicDetails
            },
            {
                type: "text",
                label: "Power Output",
                value: item.watts ? `${item.watts}W` : "-",
                privateDetails: usePublicDetails
            },
            {
                type: "text",
                label: "Created by",
                value: item.created_by_name,
                privateDetails: usePublicDetails,
            },
            {
                type: "date",
                label: "Date Created",
                value: item.date_created,
                privateDetails: usePublicDetails,
            },
            {
                type: "date",
                label: "Last Updated",
                value: item.last_updated,
                privateDetails: usePublicDetails
            },
        ])


    }, [item])

    useEffect(() => {
        setItem(props.item)
        console.log("props.item", props.item)
    }, [props.item])

    return(
        <div className="admin-single-item-view-page-container">
            <div className="content-of-admin-single-item-view-page-container">

                <div className="sections-of-admin-single-item-view-page-container">
                    <div className="content-of-sections-of-admin-single-item-view-page-container">

                        <div className="section-of-admin-single-item-view-page-container thumbnail">
                            <div className="content-of-section-of-admin-single-item-view-page-container">
                                <SectionBoxContainer>
                                    {/* {loading ? <Skeleton variant="rectangular" /> : item.thumbnail ? <img src={item.thumbnail} /> :  <Avatar><GenerateIcon icon="image" /></Avatar>} */}
                                    {loading ? <Skeleton variant="rectangular" /> : <Thumbnail src={item.thumbnail} />}
                                </SectionBoxContainer>
                            </div>
                        </div>

                        <div className="section-of-admin-single-item-view-page-container text">
                            <div className="content-of-section-of-admin-single-item-view-page-container">
                                <SectionBoxContainer loading={loading} showTitle title="Details" description="Here are the items details">
                                    {!loading ? <BasicDataViewer loading={basicDataViewerItems[0].value ? false : true} items={basicDataViewerItems} /> : <BasicDataViewer items={[
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        },
                                        {
                                            type: "text",
                                            label: "",
                                            value: "",
                                            loading: true
                                        }
                                    ]} />}

                                    {/* {!usePublicDetails && (
                                        <>
                                            <div className="head-box-of-section-box-admin-panel secondary">
                                                <div className="content-of-head-box-of-section-box-admin-panel">
                                                    <h3>Qr Code</h3>
                                                </div>
                                            </div>

                                            <ItemQrCode loading={loading} item={item} />
                                        </>
                                    )} */}

                                </SectionBoxContainer>
                            </div>
                        </div>

                    </div>
                </div>

                {!loading && item && <SingleItemQuantity item={item} usePublicDetails={usePublicDetails} />}

                {!loading && item && item.images && item.images.length > 0 && <SectionBoxContainer title="Other Images" showTitle><Attachments attachments={item.images} disableUpload disableDelete setAttachments={(att) => {}} /></SectionBoxContainer>}

                {!loading && item && <ItemAdditionalData item={item} showAllDetails />}

                <SectionBoxContainer
                    title="Description"
                    showTitle
                >
                    {usePublicDetails ? <StatusChip type="restricted" /> : item.description ? <p className="pre-line">{item.description}</p> : <p>No description has been added yet. <a href={`/panel/items/edit/${item.id}`}>Edit now</a></p>}
                </SectionBoxContainer>

                {!loading && <ItemInventory usePublicDetails={usePublicDetails} itemUniqueId={item.unique_id} isContainer={item.is_container} containerId={item.parent_item} />}

                {!loading && item.is_container && <ContainerItems usePublicDetails={usePublicDetails} itemId={item.id} />}

                {!usePublicDetails && (
                    <SectionBoxContainer
                        title="Qr Code Generator"
                        showTitle
                    >
                        <ItemQrCode loading={loading} item={item} />
                    </SectionBoxContainer>
                )}

                <div className="item-transactions-container">
                    <ItemTransactions loading={loading} itemId={item.id} usePublicDetails={usePublicDetails} itemContained={item.parent_item ? true : false} />
                </div>

                <div className="item-transactions-container">
                    <SectionBoxContainer loading={loading} showTitle title="Issues">
                        {usePublicDetails ? <UnauthorizedBlock title="Unauthorized" message="You have to sign-in to your account in order to view the information." buttons={[ { label: "Sign-in", link: "/sign-in", color: "error" } ]} /> : loading ? <div style={{ padding: 35 }}><Skeleton variant="rectangular" width={"100%"} height={500} /></div> : <IssuesList itemId={item.id} noSectionBoxWrap hidePageHeadSection />}
                    </SectionBoxContainer>
                </div>

            </div>
        </div>
    )
}